import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import AdPlayer from "./AdPlayer";
import { PLACEMENTS, idleRounds } from "./adPlaylist";
import { useAdPlaylist } from "./AdsSync";

// Заставка при простое главного экрана. Крутит очередь заданное в панели
// число кругов (настройка аппарата: «авто» — прежняя формула, 0 — до касания)
// и закрывается сама; любое касание закрывает сразу.

// Подсказка внизу сама крутит языки — к заставке подходит кто угодно, а не тот,
// кто выбирал язык. Все три надписи лежат в одной ячейке грида друг на друге:
// ширина пилюли всегда по самой длинной (kk), и рамка не прыгает при смене.
const HINT_LANGS = ["kk", "ru", "en"];
const HINT_SWITCH_MS = 3000;

const AdvertisementModal = ({ onClose }) => {
  const { t, i18n } = useTranslation();
  const { items, settings } = useAdPlaylist(PLACEMENTS.idle);
  const [hintLang, setHintLang] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setHintLang((i) => (i + 1) % HINT_LANGS.length), HINT_SWITCH_MS);
    return () => clearInterval(timer);
  }, []);

  if (items.length === 0) return null;

  const maxPlays = idleRounds(settings.idle_rounds, items.length) * items.length;

  return (
    <motion.div
      data-testid="ad-screensaver"
      className="fixed inset-0 z-30 bg-[#0B0E14]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
      onClick={onClose}
      role="button"
      aria-label={t("advertisement.tap_to_start")}
    >
      <AdPlayer
        items={items}
        placement={PLACEMENTS.idle}
        variant="fullscreen"
        maxPlays={maxPlays}
        onFinished={onClose}
        className="w-full h-full"
      />

      {/* Компактная и у самого края: подсказка не должна перекрывать ролик —
          авторы рекламы кладут текст и логотипы и в нижнюю часть кадра. */}
      <div className="absolute inset-x-0 bottom-[1.6vh] flex justify-center pointer-events-none">
        <div
          data-testid="ad-hint"
          className="flex items-center gap-[0.6vh] px-[1.6vh] py-[0.7vh] rounded-full bg-white/80 text-[#12161F] shadow-[0_0.4vh_1.2vh_rgba(0,0,0,0.3)]"
          style={{ animation: "adHint 2.4s ease-in-out infinite" }}
        >
          <svg className="w-[1.6vh] h-[1.6vh]" viewBox="0 0 24 24" fill="none" stroke="#246CE2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V11" />
            <path d="M12 10.5V9a1.5 1.5 0 0 1 3 0v2" />
            <path d="M15 10.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-.6a6 6 0 0 1-4.9-2.5L4 15a1.5 1.5 0 0 1 2.4-1.8L9 15" />
          </svg>
          <span className="grid text-[1.3vh] font-semibold">
            {HINT_LANGS.map((lng, i) => (
              <span
                key={lng}
                lang={lng}
                className={`[grid-area:1/1] text-center transition-opacity duration-500 ${i === hintLang ? "opacity-100" : "opacity-0"}`}
                aria-hidden={i !== hintLang}
              >
                {i18n.getFixedT(lng)("advertisement.tap_to_start")}
              </span>
            ))}
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default AdvertisementModal;
